//Kenneth Pickett - 2022, Tombras

//Establish Event Listeners For Menu Buttons
export default async nav => {

    let navMenu = '';
    let drawerState = "closed";
    const primaryNavigation = document.getElementById('primaryNavigation');
    document.addEventListener('click', function (event) {
        if (drawer.classList.contains("tw-max-h-screen") && !event.target.isEqualNode(primaryNavigation) && drawerState == "open" && (window.innerWidth > 960)) {
            navMenu = '';
            closeDrawer();
        }
    });
    const drawer = document.getElementById('navigationDrawer');
    const menuClosed = document.getElementById('menuClosed');
    const menuOpen = document.getElementById('menuOpen');
    const mobile = document.getElementById("mobile");
    const mobileBackLinks = nav.querySelectorAll('[mobile-back]');
    const mobileContainers = nav.querySelectorAll('[mobile-container]');
    const mobileMenuLinks = nav.querySelectorAll('[mobile-link]');
    const mobileSelect = document.getElementById('mobileSelect');
    const primaryMenuLinks = nav.querySelectorAll('[link="primary-menu"]');
    const searchContent = document.getElementById('searchContent');
    const searchClose = document.getElementById('searchClose');
    document.getElementById("mob").addEventListener("click", mobileTrigger, false);
    document.getElementById("searchOpen").addEventListener("click", searchSlideOut, false);
    document.getElementById("searchClose").addEventListener("click", searchSlideIn, false);
    window.addEventListener("resize", closeDrawer, false);

    for (let i = 0, l = primaryMenuLinks.length; i < l; i++) 
        primaryMenuLinks[i].addEventListener('click', menuTrigger, false);

    for (let i = 0, l = mobileBackLinks.length; i < l; i++)
        mobileBackLinks[i].addEventListener('click', returnSlide, false);

    for (let i = 0, l = mobileMenuLinks.length; i < l; i++)
        mobileMenuLinks[i].addEventListener('click', mobileSlide, false);

    function clearDrawer() {
        var nodes = document.getElementById('drawerInterior').getElementsByTagName("div");
        for (var i = 0; i < nodes.length; i++) {
            if (nodes[i].classList.contains("tw-flex")) {
                nodes[i].classList.remove("tw-flex");
                nodes[i].classList.add("tw-hidden");
            }
        }
    }

    function closeDrawer() {

        if (drawer.classList.contains("tw-max-h-screen")) {
            drawer.classList.remove("tw-max-h-screen");
            drawer.classList.add("tw-max-h-0");
            drawerState = "closed";
        }

    }

    function iconSwap() {
        if (menuOpen.classList.contains("tw-hidden")) {
            menuOpen.classList.remove("tw-hidden");
            menuOpen.classList.add("tw-block");
            menuClosed.classList.remove("tw-block");
            menuClosed.classList.add("tw-hidden");
        }

        else if (menuOpen.classList.contains("tw-block")) {
            menuOpen.classList.remove("tw-block");
            menuOpen.classList.add("tw-hidden");
            menuClosed.classList.remove("tw-hidden");
            menuClosed.classList.add("tw-block");
        }
    }

    function menuTrigger() {
        if (!this.id)
            return;

        toggleMenu(this.id);
    }

    function mobileSlide() {
        const container = this.getAttribute('mobile-link');

        var toggleType = this.getAttribute('toggle-type');
        if (toggleType && toggleType === 'Promotional') {
            toggleMenu(container);
            iconSwap();
            return;
        }

        mobileSelect.classList.remove("tw-block");
        mobileSelect.classList.add("tw-hidden");

        for (let i = 0, l = mobileContainers.length; i < l; i++) {            
            const containerId = mobileContainers[i].getAttribute('mobile-container');
            
            if (containerId) {
                if (containerId === container) {
                    mobileContainers[i].classList.remove("tw-hidden");
                    mobileContainers[i].classList.add("tw-block");
                } else {
                    mobileContainers[i].classList.remove("tw-block");
                    mobileContainers[i].classList.add("tw-hidden");
                }
            }
        }
    }

    function mobileTrigger() {
        iconSwap();
        
        if (navMenu != "mob") {
            closeDrawer();
            clearDrawer();
            navMenu = "mob";
            setTimeout(() => {
                if (mobile.classList.contains("tw-hidden")) {
                    mobile.classList.remove("tw-hidden");
                    mobile.classList.add("tw-flex");
                }
                openDrawer();
            }, "200")
        }
        else if (drawerState == "open" && navMenu == "mob") {
            closeDrawer();
        }
        else if (drawerState == "closed" && navMenu == "mob") {
            openDrawer();
        }
    }

    function openDrawer() {

        if (drawer.classList.contains("tw-max-h-0")) {
            drawer.classList.remove("tw-max-h-0");
            drawer.classList.add("tw-max-h-screen");
            drawerState = "open";
        }

    }

    function returnSlide() {
        for (let i = 0, l = mobileContainers.length; i < l; i++) {
            mobileContainers[i].classList.remove("tw-block");
            mobileContainers[i].classList.add("tw-hidden");
        }

        mobileSelect.classList.remove("tw-hidden");
        mobileSelect.classList.add("tw-block");
    }

    function searchSlideOut() {

        if (searchContent.classList.contains("tw-w-0")) {
            searchContent.classList.remove("tw-w-0");
            searchContent.classList.add("tw-w-full");
            searchContent.classList.add("lg:tw-w-1/3");
        }

        if (searchClose.classList.contains("tw-hidden")) {
            searchClose.classList.remove("tw-hidden");
            searchClose.classList.add("tw-flex");
        }
    }
    
    function searchSlideIn() {

        if (searchContent.classList.contains("lg:tw-w-1/3")) {
            searchContent.classList.remove("lg:tw-w-1/3");
            searchContent.classList.remove("tw-w-full");
            searchContent.classList.add("tw-w-0");
        }

        if (searchClose.classList.contains("tw-flex")) {
            searchClose.classList.remove("tw-flex");
            searchClose.classList.add("tw-hidden");
        }
    }

    function toggleMenu(uid) {
        const container = nav.querySelector(`[container="${uid}"]`);
        const navigation = nav.querySelector(`[navigation="${uid}"]`);
        const selected = document.getElementById(uid);
        const menuContent = container.querySelector('.menuContent');
        if (menuContent) {
            menuContent.style.paddingLeft = selected.getBoundingClientRect().x + 10 + 'px';
        }
                  
        if (navMenu != uid) {
            closeDrawer();
            clearDrawer();
            navMenu = uid;          
            setTimeout(() => {
                if (container && container.classList.contains("tw-hidden")) {
                    container.classList.remove("tw-hidden");
                    container.classList.add("tw-flex");
                }
                if (navigation && navigation.classList.contains("tw-hidden")) {
                    navigation.classList.remove("tw-hidden");
                    navigation.classList.add("tw-flex");
                }
                openDrawer();
            }, "200")
        }
        else if (drawerState == "open" && navMenu == uid) {
            closeDrawer();
        }
        else if (drawerState == "closed" && navMenu == uid) {
            openDrawer();
        }
    }
}



